import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Card, Divider, Grid, Typography, useTheme } from '@mui/material';
import { ButtonBasic } from '../../components';

const ModalCancelarPreTicketView = ({show, hideModal, item}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {`CORREO INVALIDO #${item?.idCorreo_ptke} - ${item?.subject_ptke}`}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important', border: 1, borderColor: isDarkMode ? '#3d4a62' : '#000', p: 1}}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', textAlign:'center',mb: 0.5, fontWeight: 'bold'}} variant='h5'>MOTIVO</Typography>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>{item?.motivoCancelado_ptke}</Typography>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important', border: 1, borderColor: isDarkMode ? '#3d4a62' : '#000', p: 1}}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',textAlign:'center',mb: 0.5, fontWeight: 'bold'}} variant='h5'>DESCRIPCION</Typography>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>{item?.observacion_ptke}</Typography>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='CERRAR'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        sx={{borderRadius: '8px !important'}}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalCancelarPreTicketView;